import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaCheck, FaRegFilePdf, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

function SubscriptionManagement() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Customer Name",
      accessorKey: "customer_name",
    },
    {
      header: "Phone",
      accessorKey: "phone",
    },
    {
      header: "Package Name	",
      accessorKey: "heading",
    },
    {
      header: "Amount",
      accessorKey: "amount",
    },
    {
      header: "Expire Date	",
      accessorKey: "expire_date",
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (row) => (row.getValue() === 0 ? "Pending" : "Approved"),
    },

    {
      header: "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];
  const [data, setData] = useState([]);

  const dropdownOptions = [
    {
      name: "Approve",
      icon: <FaCheck />,
      func: (id) => {
        approveSubscriber(id);
      },
    },
    {
      name: "Generate Card",
      icon: <FaRegFilePdf />,
      func: (id) => {
        generateCard(id);
      },
    },
    {
      name: "Delete",
      icon: <FaTrash />,
      func: (id) => {
        deleteSubscriber(id);
      },
    },
  ];

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/subscriber`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(
          res.data.map((item) => ({
            ...item,
            customer_name: item?.customers?.name,
            phone: item?.customers?.phone,
          }))
        );
      })
      .catch((err) => {});
  }, [user?.token]);

  const approveSubscriber = (id) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/subscriber/approve/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const generateCard = (id) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/subscriber/card/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const deleteSubscriber = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/subscriber/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main>
      <CardTable data={data} columns={columns} />
    </main>
  );
}

export default SubscriptionManagement;
